module.exports = __webpack_public_path__ + "img/1547574274.63baf7de.jpg";